import { mkTrackAttrs } from '@/analytics/track';

const PREFIX = 'share_thread' as const;

// Copy Link Button
export const mkCopyLinkBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__copy_link_btn`, props);
